{
  "level": "Level",
  "academicDegree": "Study programme",
  "all": "All",
  "readMore": "Read more",
  "levels": {
    "Bachelor": "Bachelor",
    "Master": "Master",
    "PhD": "PhD",
    "Executive": "Executive education"
  },
  "filter": {
    "header": "Filter",
    "toggleButton": "Filter",
    "resetButton": "Reset filters",
    "applyButton": "Show {{count}} results",
    "closeButton": "Close filter"
  }
}
